/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFBadRequestError
 */
export interface CRSFBadRequestError {
    /**
     * 
     * @type {string}
     * @memberof CRSFBadRequestError
     */
    message: string;
    /**
     * 
     * @type {number}
     * @memberof CRSFBadRequestError
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof CRSFBadRequestError
     */
    title: string;
}

/**
 * Check if a given object implements the CRSFBadRequestError interface.
 */
export function instanceOfCRSFBadRequestError(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "message" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "title" in value;

    return isInstance;
}

export function CRSFBadRequestErrorFromJSON(json: any): CRSFBadRequestError {
    return CRSFBadRequestErrorFromJSONTyped(json, false);
}

export function CRSFBadRequestErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFBadRequestError {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': json['message'],
        'status': json['status'],
        'title': json['title'],
    };
}

export function CRSFBadRequestErrorToJSON(value?: CRSFBadRequestError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
        'status': value.status,
        'title': value.title,
    };
}

